<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{
        'ADMINISTRATION.FLOWS.TABLE.ASSIGN_ROOM' | translate
      }}</span>
      <button
        mat-icon-button
        (click)="matDialogRef.close('close')"
        aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div class="my-16 mx-16" fxLayout="column">
    <div class="h4">
      Salas asignadas: <span class="text-bold">{{ countAssignedRooms }}</span>
    </div>
  </div>

  <div class="mail-list" [@animateStagger]="{ value: '50' }" fusePerfectScrollbar>
    <beplic-assig-flow-list-item
      *ngFor="let flow of flows"
      [mail]="flow"
      [@animate]="{ value: '*', params: { y: '100%' } }"
      style="padding: 10px 16px"
      (selectedItem)="selectedItem($event)"
      [ngClass]="{
        'red-text': flow.validSelection === false,
        'green-text': flow.validSelection === true
      }">
    </beplic-assig-flow-list-item>
  </div>

  <button
    mat-raised-button
    (click)="submit()"
    class="mat-accent"
    aria-label="Close"
    style="width: 220px; margin: 16px auto; display: block"
    [disabled]="checkValidFlowSelection()">
    {{ 'ACCEPT' | translate }}
  </button>
</div>
